export default __webpack_public_path__ + "static/media/15-1.fd37ecd4.mp3";